import clearIsDirty from '../../actions/clearIsDirty';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import saveWeekStartOption from '../../actions/weekStart/saveWeekStartOption';
import setMailboxCalendarConfiguration from 'mini-options-store/lib/services/setMailboxCalendarConfiguration';
import updateUserOptions from '../../utils/updateUserOptions';
import WeekStartViewState from '../../store/schema/WeekStartViewState';
import { getOptionsStore } from '../../store/Store';
import { hideFullScreenSpinner, showFullScreenSpinner } from 'mini-full-screen-spinner';
import { orchestrator } from 'satcheljs';
import { weekStartChanged } from '../../actions/weekStart/weekStartChanged';

const saveWeekStartOptionOrchestrator = orchestrator(saveWeekStartOption, async () => {
    const optionsStore = getOptionsStore();
    if (optionsStore?.activeViewState) {
        const viewState = optionsStore.activeViewState as WeekStartViewState;
        const { WeekStartDay } = viewState;

        const originalWeekStartDay = getUserConfiguration()?.UserOptions?.WeekStartDay;

        if (originalWeekStartDay !== WeekStartDay) {
            // This means the configuration has changed

            // start the spinner
            showFullScreenSpinner();

            // perform the update
            const response = await setMailboxCalendarConfiguration({
                WeekStartDay: WeekStartDay as number,
            });

            // update the configuration if we have a success and clear the flag
            if (response?.WasSuccessful) {
                updateUserOptions({
                    UserOptions: {
                        WeekStartDay,
                    },
                });
                clearIsDirty(); // clear the flag only on a success so that the save button is disabled only on a success
            }

            // remove the spinner
            hideFullScreenSpinner();

            weekStartChanged();
        } else {
            clearIsDirty(); // nothing to save
        }
    }
});

export default saveWeekStartOptionOrchestrator;
